import axios from "axios";
import { useEffect, useRef, useState } from "react";
import CONFIG from "../../constanta/config";
import SheetJSReactAoO from "../../components/exportFile";
import moment from "moment";
import QRCode from "react-qr-code";
import { toPng } from "html-to-image";

const PageReport = () => {
  const elementRef = useRef(null);
  const [allUser, setAllUser] = useState([]);
  const [loadingAllData, setLoadingAllData] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllUser();
  }, []);

  const deleteUser = (data) => {
    if (window.confirm("STOP!!! YAKIN YA MAU HAPUS DATA? " + data.nama.toUpperCase())) {
      deleteData(data.id);
    } else {
    }
  };

  const deleteData = (id) => {
    setLoading(true);

    const payload = {
      id: id,
    };

    axios
      .post(CONFIG.URL + "/delete-user", payload)
      .then(function (response) {
       

        if (response.status === 200) {
          setTimeout(() => {
            getAllUser();
          }, 2000);
        } else {
        }

        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  };

  const getAllUser = () => {
    setLoadingAllData(true);
    axios
      .get(`${CONFIG.URL}/user`)
      .then(function (response) {
        setLoadingAllData(false);
        if (response.status === 200) {
          setAllUser(response?.data);
        } else {
        }
      })
      .catch(function (error) {
        setLoadingAllData(false);
      });
  };

  const downloadQR = () => {
    toPng(elementRef.current, { cacheBust: false })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = `QR ${selectedUser.name}.png`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {selectedUser !== null && (
        <div className="absolute flex flex-col justify-center items-center z-20 top-0 left-0 w-screen h-screen bg-[#000000d6]">
          <div ref={elementRef} className="w-full max-w-sm p-5 bg-white">
            <QRCode
              size={256}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={selectedUser?.qr_code}
            />
          </div>
          <div className="w-full max-w-sm flex justify-center space-x-3 mt-5">
            <button
              onClick={() => setSelectedUser(null)}
              className={`px-5 py-2 bg-red-600 font-bold text-white rounded-lg`}
            >
              CLOSE
            </button>

            <button
              onClick={() => downloadQR()}
              className={`w-full px-5 py-2 bg-blue-500 font-bold text-white rounded-lg`}
            >
              Download
            </button>
          </div>
        </div>
      )}

      <div className="bg-white min-w-full w-auto min-h-screen h-auto py-5 px-5 overflow-x-auto ">
        <div className="flex space-x-5 items-center">
          <div className="text-xl font-bold">Report</div>
          <SheetJSReactAoO loadingAllData={loadingAllData} data={allUser} />
        </div>
        <div className="mt-5 ">
          <div className="flex">
            <div className="flex flex-none  w-10 px-2 py-1 font-bold border-b border-b-black">
              No
            </div>
            <div className="flex flex-none flex-grow w-60 px-2 py-1 font-bold border-b border-b-black">
              Nama
            </div>
            <div className="flex flex-none flex-grow w-40 px-2 py-1 font-bold border-b border-b-black">
              Kota
            </div>
            <div className="flex flex-none  flex-grow w-60 px-2 py-1 font-bold border-b border-b-black">
              Time Check In
            </div>
            <div className="flex flex-none  flex-grow w-60 px-2 py-1 font-bold border-b border-b-black">
              Time ⁠Kick Off 2024
            </div>
            <div className="flex flex-none  flex-grow w-60 px-2 py-1 font-bold border-b border-b-black">
              Time Health Session
            </div>
            <div className="flex flex-none  flex-grow w-60 px-2 py-1 font-bold border-b border-b-black">
              DELETE
            </div>
          </div>
          <div>
            {allUser?.map((user, key) => {
              return (
                <div key={key} className="flex">
                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none  w-10 px-2 py-1 border-b border-b-black`}
                  >
                    {key + 1}
                  </div>
                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none  flex-grow w-60 px-2 py-1 border-b border-b-black uppercase `}
                  >
                    {user.nama}
                  </div>
                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none flex-grow w-40 px-2 py-1 border-b border-b-black uppercase`}
                  >
                    {user.kota}
                  </div>

                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none flex-grow  w-60 px-2 py-1 border-b border-b-black`}
                  >
                    {user.time_meeting === "0000-00-00 00:00:00"
                      ? "-"
                      : moment(user.time_meeting).format(
                          "HH:mm:ss,  YYYY-MM-DD"
                        )}
                  </div>

                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none flex-grow  w-60 px-2 py-1 border-b border-b-black`}
                  >
                    {user.time_dinner === "0000-00-00 00:00:00"
                      ? "-"
                      : moment(user.time_dinner).format(
                          "HH:mm:ss,  YYYY-MM-DD"
                        )}
                  </div>

                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none flex-grow  w-60 px-2 py-1 border-b border-b-black`}
                  >
                    {user.time_motivational === "0000-00-00 00:00:00"
                      ? "-"
                      : moment(user.time_motivational).format(
                          "HH:mm:ss,  YYYY-MM-DD"
                        )}
                  </div>

                  <div
                    className={`${
                      key % 2 === 0 ? "bg-gray-100" : ""
                    } flex flex-none flex-grow  w-60 px-2 py-1 border-b border-b-black`}
                  >
                    <button
                      onClick={() => deleteUser(user)}
                      className="px-2 bg-red-500 text-white rounded-md"
                    >
                      {loading ? "loading..." : "DELETE"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default PageReport;
